/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RealizaciaRouteImport } from './routes/realizacia'
import { Route as OchranaOsobnychUdajovRouteImport } from './routes/ochrana-osobnych-udajov'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as IndexRouteImport } from './routes/index'

const RealizaciaRoute = RealizaciaRouteImport.update({
  id: '/realizacia',
  path: '/realizacia',
  getParentRoute: () => rootRouteImport,
} as any)
const OchranaOsobnychUdajovRoute = OchranaOsobnychUdajovRouteImport.update({
  id: '/ochrana-osobnych-udajov',
  path: '/ochrana-osobnych-udajov',
  getParentRoute: () => rootRouteImport,
} as any)
const KontaktRoute = KontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/kontakt': typeof KontaktRoute
  '/ochrana-osobnych-udajov': typeof OchranaOsobnychUdajovRoute
  '/realizacia': typeof RealizaciaRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/kontakt': typeof KontaktRoute
  '/ochrana-osobnych-udajov': typeof OchranaOsobnychUdajovRoute
  '/realizacia': typeof RealizaciaRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/kontakt': typeof KontaktRoute
  '/ochrana-osobnych-udajov': typeof OchranaOsobnychUdajovRoute
  '/realizacia': typeof RealizaciaRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/kontakt' | '/ochrana-osobnych-udajov' | '/realizacia'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/kontakt' | '/ochrana-osobnych-udajov' | '/realizacia'
  id: '__root__' | '/' | '/kontakt' | '/ochrana-osobnych-udajov' | '/realizacia'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KontaktRoute: typeof KontaktRoute
  OchranaOsobnychUdajovRoute: typeof OchranaOsobnychUdajovRoute
  RealizaciaRoute: typeof RealizaciaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/realizacia': {
      id: '/realizacia'
      path: '/realizacia'
      fullPath: '/realizacia'
      preLoaderRoute: typeof RealizaciaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ochrana-osobnych-udajov': {
      id: '/ochrana-osobnych-udajov'
      path: '/ochrana-osobnych-udajov'
      fullPath: '/ochrana-osobnych-udajov'
      preLoaderRoute: typeof OchranaOsobnychUdajovRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kontakt': {
      id: '/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof KontaktRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KontaktRoute: KontaktRoute,
  OchranaOsobnychUdajovRoute: OchranaOsobnychUdajovRoute,
  RealizaciaRoute: RealizaciaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
